import ApiClient from "@/ApiClient";

export default {
  install(app) {
    const apiClient = new ApiClient();

    app.config.globalProperties.$apiClient = apiClient;

    app.mixin({
      created() {
        this.$apiClient = apiClient;
      }
    });
  }
};